<template>
  <Modal
    v-model="_value"
    width="650"
    title="JT808设置终端参数设置"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <div style="position:relative;">
      <span>主机号：{{_initData}}</span>
    <Table :columns="columns" :data="data" height="350" size="small">
      <template slot-scope="{ row, index }" slot="parameterdata">
        <Input  size="small" type="text" v-model="editparameterdata" v-if="editIndex === index" />
        <span v-else>{{ row.parameterdata }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <div v-if="editIndex === index">
          <Button size="small" type="primary" @click="handleSave(index)">保存</Button>
          <Button size="small" type="error" @click="editIndex = -1">取消</Button>
        </div>
        <div v-else>
          <Button size="small" type="primary" @click="handleEdit(row, index)">操作</Button>
        </div>
      </template>
    </Table>
    <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
      <Spin size="large"></Spin>
      <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
    </div>
    </div>
      <Button type="primary" style="margin-right: 3px;position: relative;top: 25px;" size="small" @click="addparameterdata">添加终端参数</Button>
      <Button type="primary" style="margin-right: 3px;position: relative;top: 25px;" size="small" @click="onExportExcelClick">导出Excel</Button>
    <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
          show-elevator @on-change="setPage"
          style="text-align:right;margin-top:3px;"></Page>
  <jt808-add-parameterdata-modal v-model="jt808AddParameterdataModal" :initValue="jt808AddParameterdataId" :initData="jt808AddParameterdata" @refresh="refresh"></jt808-add-parameterdata-modal>
  </Modal>


</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { genURLParams } from '@/libs/urlparamhelper'
import Jt808AddParameterdataModal from '@/view/ddm/components/jt808-add-parameterdata-modal'


export default {
  name: 'jt808-set-parameterdata-modal',
  components:{
    Jt808AddParameterdataModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    initData: null
  },
  data () {
    return {
      data: [],

      listLoadding: false,

      pageIndex: 1,

      columns: [
        {
          title: 'id',
          resizable: true,
          key: 'id',
          tooltip: 'true',
          width: 50
        },
        {
          title: '参数名称',
          resizable: true,
          key: 'parametername',
          ellipsis: 'true',
          width: 200
        },
        {
          title: '数值',
          resizable: true,
          key: 'parameterdata',
          ellipsis: 'true',
          slot: 'parameterdata'
        },
        {
          title: '更新时间',
          resizable: true,
          key: 'updateDatetime',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          width: 80,
          slot: 'action'
        }
      ],
      editIndex: -1, // 当前聚焦的输入框的行数
      editparameterdata: '', // 第一列输入框，当然聚焦的输入框的输入内容，与 data 分离避免重构的闪烁

      jt808AddParameterdataModal:false,
      jt808AddParameterdataId:null,
      jt808AddParameterdata:null
    }
  },
  methods: {
    ...mapActions([
      'Jt808DeviceServ_ResetAllReportInterval'
    ]),
    onOk () {
    },
    visibleChange (val) {
      if (val) {
        this.setPage(this.pageIndex)
      }
    },

    handleEdit (row, index) {
      this.editparameterdata = row.parameterdata
      this.editIndex = index
    },
    handleSave (index) {
      this.data[index].parameterdata = this.editparameterdata
      this.editIndex = -1

      store.dispatch('Jt808ParameterDataServ_ModifyObj', {
        params:
            this.data[index],
        urlparams: null
      }).then(() => {
        this.setPage(this.pageIndex)
      }).catch(err => {
        this.$Message.error(err)
      })
    },

    setPage (page) {
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      queryParams.push(genQueryParam('jt808deviceid', 'EQ', this._initValue))
      store.dispatch('Jt808ParameterDataServ_GetPage', {
        params: null,
        urlparams: {
          p: page,
          keyword: this.keywordFilter,
          q: queryParams
        }
      }).then(() => {
        this.data = store.getters.get_Jt808ParameterData_GetPageResult.content
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },

    onExportExcelClick () {
      let queryParams = []
      queryParams.push(genQueryParam('jt808deviceid', 'EQ', this._initValue))
      let urlparams = {
        q: queryParams
      }
      let url = '/api/ddm/jt808parameterdata/exportexcel' + genURLParams(urlparams)
      window.location.href = url
    },

    addparameterdata(){
      this.jt808AddParameterdataModal = true
      this.jt808AddParameterdataId = this._initValue
      this.jt808AddParameterdata = this._initData
    },
    refresh(val){
      this.setPage(this.pageIndex)
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _initData: {
      get () {
        return this.initData
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    totalElements () {
      if (store.getters.get_Jt808ParameterData_GetPageResult) {
        return store.getters.get_Jt808ParameterData_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    pageSize () {
      if (store.getters.get_Jt808ParameterData_GetPageResult) {
        return store.getters.get_Jt808ParameterData_GetPageResult.size
      } else {
        return 0
      }
    }

  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

</style>
